/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, cx, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	divider: {
		width: '100%',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
	},
	thinDivider: {
		width: '100%',
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
	dividerMargin: {
		marginTop: token('space.100'),
		marginBottom: token('space.100'),
	},
});

export const Divider = ({
	isThin = false,
	withMargin = false,
}: {
	isThin?: boolean;
	withMargin?: boolean;
}): JSX.Element => {
	return (
		<Box
			xcss={cx(!isThin ? styles.divider : styles.thinDivider, withMargin && styles.dividerMargin)}
			backgroundColor="color.background.neutral.subtle"
			role="separator"
		/>
	);
};
